import { useMemo } from 'react'
import { useGetOngoingPurchasesQuery } from 'Hooks/api/user/purchases/useGetOngoingPurchasesQuery'
import { useGetPendingOPRPurchasesQuery } from 'Hooks/api/user/purchases/useGetPendingOPRPurchasesQuery'

export type OngoingPurchaseProgram = {
  name: string
  ongoingPurchases: boolean
  allowance: number
  threshold: number
}

export const useOngoingPurchaseInfo = (
  userId?: number,
  program?: OngoingPurchaseProgram,
  amount?: number
) => {
  const { data } = useGetOngoingPurchasesQuery(userId)
  const { data: pendingOprData, isFetching } = useGetPendingOPRPurchasesQuery(1, 1, {}, userId)

  const hasPendingOngoingPurchase = useMemo(() => {
    return pendingOprData?.purchasesCount !== 0 && isFetching === false
  }, [pendingOprData, isFetching])

  const pendingOngoingPurchase = useMemo(() => {
    return !isFetching && pendingOprData?.data?.purchases?.length
      ? pendingOprData.data.purchases[0]
      : undefined
  }, [pendingOprData, isFetching])

  if (!program) {
    return {
      ongoingPurchases: false,
      ongoingPurchaseThreshold: 0,
      hasPendingOngoingPurchase,
      pendingOngoingPurchase,
      purchaseAmountRequired: 0,
      amountMeetsThreshold: false,
      activeOngoingPurchaseForProgram: false
    }
  }

  const purchaseAmountRequired = program.allowance * program.threshold

  const amountMeetsThreshold = amount ? amount >= purchaseAmountRequired : false

  const activeOngoingPurchaseForProgram = !!data?.ongoingPurchases.find(
    (p) => p.programName === program.name && p.calculatedRemainingAmount > 0
  )

  return {
    ongoingPurchases: program.ongoingPurchases,
    ongoingPurchaseThreshold: program.threshold,
    purchaseAmountRequired,
    hasPendingOngoingPurchase,
    pendingOngoingPurchase,
    amountMeetsThreshold,
    activeOngoingPurchaseForProgram
  }
}
